import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  HostListener,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
} from "@angular/core";
import { AgGridTableService } from "../../services/ag-grid.service";
import { Observable, Subscription, takeUntil } from "rxjs";
import { CommonModule } from "@angular/common";
import { AgGridAngular } from "ag-grid-angular";
import { GridApi } from "ag-grid-community";
import { ApiCallsService } from "../../services/api-calls.service";
import { ActivatedRoute, RouterModule } from "@angular/router";
import {
  FlatpickrDirective, provideFlatpickrDefaults,
} from "angularx-flatpickr";
import { getFlatpickrDefaults } from "../flatpickr-defaults";
import { SiteSearchService } from "../../services/site-search.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
export interface DropdownItem {
  site_id: string;
  site_name: string;
  selected: boolean;
}
interface Site {
  site_id: string;
  site_name: string;
}
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import { FormsModule } from "@angular/forms";
import { DestroyableComponent } from "../../services/destroyable.component";
import { ReportPaginationService } from "../../../component/DashboardScreens/Reports/report-pagination.service";
import { LogsPaginationService } from "../../../component/DashboardScreens/log/log-table/logs-pagination.service";
import { ToastService } from "../../services/toast.service";
import { environment } from "../../../../environments/environment";
import { ConfigPaginationService } from "../../../component/DashboardScreens/configuration/configpagination.service";
import { TableDataPaginationService, TableDataPayload } from "./table.service";
import { FormModalComponent } from "../form-modal/form-modal.component";
import Swal from 'sweetalert2';


@Component({
  selector: "app-table",
  templateUrl: "./table.component.html",
  imports: [
    CommonModule,
    NgbModule,
    AgGridAngular,
    FormsModule,
    NgbTooltipModule,
    FlatpickrDirective,
    NgSelectModule,
    RouterModule,
    FormModalComponent,
    NgbModule],
  standalone: true,
  styleUrl: "./table.component.scss",
  providers: [provideFlatpickrDefaults(getFlatpickrDefaults())],
})


export class TableComponent extends DestroyableComponent implements OnInit, OnDestroy {
  sitename: string;
  modal: any

  rowSelection: 'multiple' = 'multiple';
  openCalendar(): void {
    this.flatpickr?.instance?.open();
  }
  flatpickr!: FlatpickrDirective;

  dateRange: string | Date[] | Date = [// Setting date Range
    new Date(new Date().setDate(new Date().getDate() - 1)),
    new Date(),
  ];
  showmodal: boolean = true
  columnApi: any
  @Input() location: boolean = false
  @Input() pdf: boolean = true
  @Input() csv: boolean = true
  @Input() config: boolean = false
  @Input() analytic: boolean = false
  sites: Site[] = [];
  searchTerm = '';
  selectedValue: string = '';
  internalOptions: Site[] = [];
  selectedCommand: string = '';
  CustomOutlineData = [
    {
      item: [
        {
          class: 'btn-outline-primary',
          text: 'Site',
          key: 'site_wise'
        },
        {
          class: 'btn-outline-primary',
          text: 'Gateway',
          key: 'gateway'
        }

      ]
    },
  ]
  autoSizeStrategy: {
    type: 'fitCellContents'
  }

  editId: string = ''
  @Input() ResetPage: boolean = false
  @Output() DataTypeDatalogger = new EventEmitter<string>()
  isLoading = false; // Property to track loading state
  isFloatingFilterEnabled = true;
  filterIcon = "assets/images/Icons/filter-active.png";
  receivedData = "";
  showColumnMenu = false;
  isHideAllDisabled = false;
  isShowAllDisabled = false;
  tableType: string = ''
  TotalRows: string = ''
  public gridApi!: GridApi;// Define AG-grid to call its inbuilt functions
  isSearchOpen = false;
  formattedFromDate: string = "";// From date
  formattedToDate: string = "";// To date
  isOpen: boolean = false
  @Input() modalId: string = ''
  grandTotalRow: "top" | "bottom" | "pinnedTop" | "pinnedBottom" = "bottom";
  pinnedBottomRowData: any[] = [];
  @Input() TableHeader: string = ''
  @Input() ShowDLFilter: boolean = false
  screenWidth: number = window.innerWidth;
  isMobileView: boolean = this.screenWidth <= 600;
  @Input() statusMap: Record<string, 'active' | 'inactive'> = {};
  @Input() filterConfig: { key: string; label: string }[] = [];
  @Input() mode: 'date' | 'month' = 'date'; // input from parent
  plugins: any[] = [];
  altFormat = 'd/m/Y';
  dateFormat = 'Y-m-d';
  placeholder = 'From - To';
  rangeMode: 'range' | 'single' = 'range';
  @Output() statusUpdated = new EventEmitter<{ key: string; value: 'inactive' }>();
  @Output() records = new EventEmitter<any>();
  selectedKey: string = 'site_wise';
  @Input() ResetPagination: boolean = false
  @Input() addApplication: boolean = false;
  @Input() addRouteUrl: string = '';
  @Output() addRouteRequested = new EventEmitter<void>();
  @Input() AddBulkaction: boolean = false;
  @Input() SiteDropDown: boolean = false;
  updateStatus(key: string): void {
    const payload: { key: string; value: 'inactive' } = { key, value: 'inactive' };
    this.statusUpdated.emit(payload);
  }
  updateViewMode(): void {// to show filters for mobile view
    this.screenWidth = window.innerWidth;
    this.isMobileView = this.screenWidth <= 600;
  }
  get activeFiltersCount(): number {
    return this.filterConfig.filter(filter => this.statusMap[filter.key] === 'active').length;
  }
  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }
  SelectDataloggerData(key: string) {
    this.selectedKey = key;  // set the selected key
    this.DataTypeDatalogger.emit(key);
  }
  Additem(payload: any) {
    console.log(payload);
    this.records.emit(payload)
  }

  columnDefs: any[] = [];
  rowData: any[] = [];
  defaultColDef = {// These are default values set for configs of ag-grid.
    resizable: true,//Can resize column
    sortable: true,
    filter: 'agTextColumnFilter',//Enable quick filter
    suppressMovable: true,//Dissable moving of rows left or right
    floatingFilter: true,
    flex: 1,// To set the table width fit and not leave empty space 
  };
  isQuickFilterActive: boolean = false;//Check if there is text inside the quick filter

  routeParam: string | null = null; // Store the dynamic route segment
  site_id: string | null = "";
  private dataSubscription!: Subscription;
  @Input() paginationPageSizeSelector: number[] | boolean = [10, 20, 50, 100];// By default pageination is this, but can be changed if given from Parent component
  shortCodeSubscription: Subscription | null;
  siteidSubscription: Subscription | null;
  rowdatasubscription: Subscription | null;

  isSiteCode: boolean = false;
  timer: any;
  private readonly onWindowResize = () => this.updateViewMode();

  @Output() filtersApplied = new EventEmitter<{  // from and to date Output to parent component
    from_date: string;
    to_date: string;
    site_id?: string;
  }>();
  @Output() filterReset = new EventEmitter<void>();
  @Input() Date: {  // from and to date Output to parent component
    from_date: string;
    to_date: string;
  }
  @Input() displayAddbutton: boolean = false
  add_edit: boolean = environment.add_edit
  @Input() pageNation: boolean = false;
  @Input() DateFilterShow: boolean = false;
  @Input() maxRowCount: number = 0;
  @Input() Reload: boolean = false
  @Input() totalDisplay: boolean = false
  @Input() buttonTitle: string;
  @Output() pageNumber = new EventEmitter<number>();
  @Output() clearSupervisorHighlight = new EventEmitter<void>();
  @Input() loader: boolean = false
  hasTriggeredLastPage = false;
  private valueSubscription!: Subscription;
  siteid: string | null = ''
  shortcode: string = ''
  @Output() onPageChange = new EventEmitter<{
    page: number;
    pageSize: number;
  }>();
  public currentPage = 1;
  public totalRows = 0;

  private pageSize: number = 10; // Default, can be changed by onPageSizeChanged
  gridOptions = {
    overlayNoRowsTemplate:
      '<span class="no-data-line">No Data found</span>'
  };

  private previousMaxRowCount: number = -1;

  constructor(
    private readonly tableService: AgGridTableService,
    private readonly apiService: ApiCallsService,
    private readonly route: ActivatedRoute,
    private readonly siteSearch: SiteSearchService,
    private readonly reportPaginationService: ReportPaginationService,
    private readonly LogPaginationService: LogsPaginationService,
    private readonly ConfigPaginationService: ConfigPaginationService,
    private readonly toast: ToastService,
    private readonly tableDataPaginationService: TableDataPaginationService
  ) {
    super()
  }
  private routeSub!: Subscription;
  timerheader: string = '';
  @Output() columnFormSubmitted = new EventEmitter<any>();

  columnFormFields: any[] = [];
  columnFormApiKey: string = '';
  columnFormTitle: string = '';
  columnFormRow: any = null;
  columnFormPayload: any = null;

  private applyPaginationColumnSettings(): void {
    if (this.pageNation) {
      this.columnDefs = this.columnDefs.map(col => ({
        ...col,
        sortable: false,
        floatingFilter: false
      }));
    } else {
      this.columnDefs = this.columnDefs.map(col => ({
        ...col,
        sortable: true,
        filter: col.filter ?? 'agTextColumnFilter',
        floatingFilter: this.isFloatingFilterEnabled
      }));
    }
    if (this.gridApi) {
      this.gridApi.setGridOption('columnDefs', this.columnDefs);
    }
  }

  onColumnFormResponse(formData: any) {
    console.log('Column form response:', formData);
    const endpoint = this.columnFormApiKey;
    if (!endpoint) {
      this.toast.showToast('No API endpoint configured for this form', 'colored', 4000, 'warning');
      return;
    }

    const payload = {
      ...(this.columnFormPayload || {}),
      ...(formData || {}),
      site_id: this.columnFormPayload?.site_id || (this.columnFormRow?.site_id ?? (this.siteid || localStorage.getItem('site_idLogin') || ''))
    };

    console.log('Final Column Form POST endpoint:', endpoint);
    console.log('Final Column Form POST payload:', payload);

    // Close the modal
    const modalEl = document.getElementById('columnFormModal');
    if (modalEl) {
      const bootstrapModal = (window as any).bootstrap?.Modal;
      if (bootstrapModal) {
        const instance = bootstrapModal.getInstance(modalEl);
        if (instance) instance.hide();
      }
    }

    const cleanEndpoint = endpoint.replace(/^\/+/, '');
    this.apiService.TowerDetailsADD(cleanEndpoint, payload).subscribe({
      next: (res) => {
        this.toast.showToast(res?.message || res?.Message || 'Data submitted successfully', 'colored', 5000, 'success');
        this.columnFormSubmitted.emit({ endpoint: cleanEndpoint, payload, response: res });
      },
      error: (err) => {
        this.toast.showToast(err?.error?.message || err?.error?.Message || 'Failed to submit data', 'colored', 5000, 'danger');
      }
    });
  }

  ngOnInit() {
    this.tableService.columnForm$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.columnFormFields = [...(data.fields || [])];
      this.columnFormApiKey = data.apiKey;
      this.columnFormTitle = data.modalTitle;
      this.columnFormRow = data.row;
      this.columnFormPayload = data.payload;

      const visibleFields = this.columnFormFields.filter(f => f.view !== false);
      const isDirectAction = !!data.confirmAction || visibleFields.length === 0;

      if (isDirectAction) {
        const warnText = data.warningMessage || `Are you sure you want to run this action?`;
        Swal.fire({
          title: 'Are you sure?',
          text: warnText,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then((result) => {
          if (result.isConfirmed) {
            this.onColumnFormResponse({});
          }
        });
        return;
      }

      setTimeout(() => {
        const modalEl = document.getElementById('columnFormModal');
        if (modalEl) {
          const bootstrapModal = (window as any).bootstrap?.Modal;
          if (bootstrapModal) {
            const instance = bootstrapModal.getInstance(modalEl) || new bootstrapModal(modalEl);
            instance.show();
          }
        }
      }, 50);
    });

    this.route.queryParamMap
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        /* 🔑 Resolve siteId */
        const encodedId =
          params.get('siteid') || localStorage.getItem('site_idLogin');

        this.siteid = encodedId ? atob(encodedId) : null;
      })

    /* -------------------- EXISTING INIT LOGIC (UNCHANGED) -------------------- */
    this.shortcode = ''

    if (this.SiteDropDown) {
      this.loadSites();
    }

    this.updateViewMode(); // initialize once

    if (this.DateFilterShow) {
      if (this.mode === 'month') {
        this.setupMonthPicker();
      } else {
        this.setupDatePicker();
      }
    }

    this.updateViewMode(); // initialize once
    window.addEventListener('resize', this.onWindowResize);

    /* -------------------- ROUTE PARAMS -------------------- */

    this.routeSub = this.route.queryParams.subscribe(params => {
      const siteName = params['site_name'];
      this.timer = sessionStorage.getItem('Timer')
      this.timer = Number(this.timer) * 60 * 60
      if (this.timer === 0) {
        this.timer = NaN
      }
      var timer = this.timer / 60
      if (timer < 60) {
        this.timerheader = timer.toString() + "min"
      }
      else {
        timer = timer / 60
        this.timerheader = timer.toString() + 'hr'
      }

      this.site_id = sessionStorage.getItem(siteName)
      this.TotalRows = sessionStorage.getItem('total') || ''
    }

    );

    /* -------------------- TABLE PAGE ROUTE -------------------- */

    this.route.url.subscribe((urlSegments) => {
      if (urlSegments.length) {
        this.routeParam = urlSegments[urlSegments.length - 1].path;
        this.fetchData(this.routeParam);

        // table is about to reload → reset readiness
        this.siteSearch.setTableReady(false);
      }
    });


    /* -------------------- TABLE DATA SUBSCRIPTION -------------------- */

    this.rowdatasubscription = this.tableService.tableData$.subscribe(
      ({ columnDefs, rowData, pinnedBottomRowData }) => {

        this.columnDefs = columnDefs;
        if (this.pageNation) {
          this.columnDefs = this.columnDefs.map(col => ({
            ...col,
            sortable: false,
            floatingFilter: false
          }));
        } else {
          this.columnDefs = this.columnDefs.map(col => ({
            ...col,
            sortable: true,
            filter: col.filter ?? 'agTextColumnFilter',
            floatingFilter: this.isFloatingFilterEnabled
          }));
        }
        this.rowData = rowData;
        this.totalRows = this.maxRowCount;
        this.pinnedBottomRowData = pinnedBottomRowData || [];
        this.loader = false;
        this.isLoading = false;

        if (this.gridApi && !this.gridApi.isDestroyed()) {
          if (this.columnDefs?.length) {
            this.gridApi.setGridOption('columnDefs', this.columnDefs);
          }
          this.gridApi.setGridOption('rowData', this.rowData);

          if (this.totalDisplay) {
            this.gridApi.setGridOption('pinnedBottomRowData', this.pinnedBottomRowData);

          } else {
            this.gridApi.setGridOption('pinnedBottomRowData', []);
          }
          this.gridApi.hideOverlay();
          // ✅ notify service that table is now ready
          this.siteSearch.setTableReady(true);
          if (this.columnDefs.length !== 0) {
            this.handleTypeQueryParam()
          }
        }
      }
    );
    /* -------------------- Pagination Reset Subscription ---------------------*/
    this.reportPaginationService.payloadChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe(changed => {
        if (changed) {
          this.ResetPagination = true
        }
      });
    this.LogPaginationService.payloadChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe(changed => {
        if (changed) {
          this.ResetPagination = true
        }
      });
    /* -------------------- SHORTCODE (AFTER TABLE READY) -------------------- */

    this.siteSearch.shortCodeWhenTableReady$.subscribe((shortCode) => {

      const filterTextBox = document.getElementById('filter-text-box') as HTMLInputElement;
      if (!filterTextBox) return;

      if (shortCode) {
        filterTextBox.value = shortCode;
        this.isSearchOpen = true
        this.onMainSearchChange();
        this.onClearSupervisor();
      } else {
        filterTextBox.value = '';
        this.isSearchOpen = false
        this.gridApi?.setGridOption('quickFilterText', '');
        this.isQuickFilterActive = false;
      }
    });

    /* -------------------- CELL FILTER SUBSCRIPTION -------------------- */

    this.valueSubscription = this.tableService.value$.subscribe((data) => {
      if (data) {
        this.receivedData = data.value;
        this.onCellFiltter(data.value, data.value1);
      }
    });
  }



  onClearSupervisor() {
    this.clearSupervisorHighlight.emit();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pageNation'] && this.columnDefs?.length) {
      this.applyPaginationColumnSettings();
    }
    if (changes["data"] || changes["resetTrigger"]) {
      this.hasTriggeredLastPage = true;
    }
    if (changes['mode']) {
      if (this.mode === 'month') {
        this.setupMonthPicker();
      } else {
        this.setupDatePicker();
      }
    }
    if (changes['Date'] && this.Date?.from_date && this.Date?.to_date) {
      if (this.mode === 'month') {
        this.dateRange = new Date(this.Date.from_date || this.Date.to_date);
      } else {
        this.dateRange = [
          new Date(this.Date.from_date),
          new Date(this.Date.to_date)
        ];
      }
    }

    if (changes['filterConfig'] && this.filterConfig?.length) {
      console.log('✅ filterConfig received in child:', this.filterConfig);
      // You can now safely use this.filterConfig
    }
  }


  //The below whole code is for Pagination in Reports and other pages with API that takes page number and size as an input
  //It works like this -> Max Count taken as input from the component, this max number is used to create an array of Max pagenumbers 
  //The parent component(Take any Reports as example) where its called, Sends the Data using processdata function of ag grid service
  //The data that sends is a array of duplicated data (Similar to Infinite Function of enterprise Ag grid but this works the same)
  //This helps to show the total numeber of existing data, total page numbers
  //Whenever next page event is run, the array updates that page, and Replaces the duplicate data with the API data

  private loadedPages: { [pageSize: number]: number[] } = {};
  private visitedPages: { [pageSize: number]: number[] } = {}; // For your updateVisitedPages logic
  private isInternalNavigationUpdate: boolean = false; // Prevents re-entrant calls in onPaginationChanged 

  public onPaginationChanged(event?: any): void {
    if (this.ResetPagination) {
      this.previousMaxRowCount = this.maxRowCount;
      this.isInternalNavigationUpdate = true;
      this.gridApi?.paginationGoToFirstPage();
      this.resetPaginationMemory();
      this.ResetPagination = false;
      return;
    }

    if (this.isInternalNavigationUpdate) {
      this.isInternalNavigationUpdate = false;
      return;
    }

    if (
      !this.pageNation ||
      !this.gridApi ||
      !this.pageSize ||
      this.maxRowCount < 0
    ) {
      return;
    }

    const agGridReportedPage_0idx = this.gridApi.paginationGetCurrentPage();
    const agGridReportedPage_1idx = agGridReportedPage_0idx + 1;
    const agGridPageSize = this.gridApi.paginationGetPageSize();

    const actualTotalServerPages = this.calculateActualTotalPages();
    let targetPageForData = agGridReportedPage_1idx;

    if (actualTotalServerPages > 0 && targetPageForData > actualTotalServerPages) {
      targetPageForData = actualTotalServerPages;
    } else if (targetPageForData < 1) {
      targetPageForData = 1;
    }

    this.currentPage = targetPageForData;

    if (!this.loadedPages[agGridPageSize]) {
      this.loadedPages[agGridPageSize] = [];
    }

    const currentLoadedPages = this.loadedPages[agGridPageSize];
    if (actualTotalServerPages === 0) {
      return;
    }

    const isInitialZeroToOne =
      this.previousMaxRowCount === 0 &&
      this.maxRowCount > 0 &&
      this.currentPage === 1;

    const isPageSizeChange = event?.newPageSize === true;
    const isUserPageNavigation = event?.newPage === true;

    if (isInitialZeroToOne) {
      // do nothing
    } else if (
      (isPageSizeChange || isUserPageNavigation) &&
      !currentLoadedPages.includes(this.currentPage)
    ) {
      // ✅ Show AG Grid's built-in loading overlay before emitting
      this.isLoading = true;
      this.gridApi.showLoadingOverlay();

      this.onPageChange.emit({
        page: this.currentPage,
        pageSize: agGridPageSize,
      });

      currentLoadedPages.push(this.currentPage);
      currentLoadedPages.sort((a, b) => a - b);
    }

    if (this.gridApi.paginationGetCurrentPage() !== this.currentPage - 1) {
      this.isInternalNavigationUpdate = true;
      this.gridApi.paginationGoToPage(this.currentPage - 1);
    }

    this.previousMaxRowCount = this.maxRowCount;
    this.updateVisitedPages();
  }


  private calculateActualTotalPages(): number {// Returns total number of pages to exist
    if (this.maxRowCount === 0) {
      return 0; // Explicitly handle the case of zero rows
    }
    if (!this.maxRowCount || !this.pageSize) {
      return 1; // Default to 1 page if data is missing, unless row count is 0
    }
    return Math.ceil(this.maxRowCount / this.pageSize);
  }


  // --- Original Helper Functions (with minor adjustments) ---
  private updateVisitedPages(): void {
    if (!this.pageSize) return; // Guard against undefined pageSize
    if (!this.visitedPages[this.pageSize]) {
      this.visitedPages[this.pageSize] = [];
    }
    if (!this.visitedPages[this.pageSize].includes(this.currentPage)) {
      this.visitedPages[this.pageSize].push(this.currentPage);//This is to help maintain an array that stores the pages api was called in, So as to not have duplicate Data
    }
  }
  private resetPaginationMemory(): void {
    this.loadedPages = {};
    this.visitedPages = {};
    this.currentPage = 1;
  }

  //pagination related code ends

  onGridReady(params: any) { // This set of code runs after the table is initiated
    this.gridApi = params.api;
    this.tableService.setGridApi(params.api); // ✅ IMPORTANT

    this.columnApi = params.columnApi;

    if (this.pageNation) {// In report pages, dont want to show the floating filter, hence set the value as false here
      this.defaultColDef = {
        ...this.defaultColDef,
        floatingFilter: false,// For tables wherever pagination is implmented, the floating filters have been removed
      };
    }

    if (this.columnDefs?.length) {
      this.gridApi.setGridOption('columnDefs', this.columnDefs);
    }
    if (this.rowData?.length) {
      this.gridApi.setGridOption('rowData', this.rowData);
    }
    if (this.totalDisplay && this.pinnedBottomRowData?.length) {
      this.gridApi.setGridOption('pinnedBottomRowData', this.pinnedBottomRowData);
    }
    this.loader = false;
    this.isLoading = false;
    this.gridApi.hideOverlay();
  }



  onCellFiltter(value?: string, field?: string): void {
    if (!field || !this.gridApi) return;

    this.gridApi.getColumnFilterInstance(field).then(filterInstance => {
      if (!filterInstance) return;

      filterInstance.setModel({
        type: 'contains',
        filter: value ?? ''
      });

      this.gridApi.onFilterChanged();
    });
  }
  today = new Date()
  @Input() ExportFileName: string = ''
  //  @Input() exportFileName: string = 'ExportedData';
  onExport(downloadtype: 'CSV' | 'PDF' = 'PDF') {
    if (this.rowData.length === 0) {
      this.toast.showToast('Table data is empty', 'colored', 5000, 'warning')
      return
    }
    if (downloadtype === 'CSV') {
      if (!this.pageNation) {
        this.gridApi.exportDataAsCsv({
          fileName: this.ExportFileName || 'ExportedData'
        });
      }
      else if (this.location) {
        this.LogPaginationService.downloadCSV(this.destroy$, this.columnDefs);
      }
      else if (this.config) {
        this.ConfigPaginationService.downloadCSV(this.destroy$, this.columnDefs);
      }
      else if (this.analytic) {
        this.tableDataPaginationService.downloadCSV(this.destroy$, this.columnDefs);
      }
      else {
        this.reportPaginationService.downloadCSV(this.destroy$, this.columnDefs);
      }
    }
    else if (downloadtype === 'PDF') {
      if (this.location) {
        this.LogPaginationService.downloadPDF(this.destroy$, this.columnDefs);
      }
      else if (this.config) {
        this.ConfigPaginationService.downloadPDF(this.destroy$, this.columnDefs);
      }
      else if (this.analytic) {
        this.tableDataPaginationService.downloadPDF(this.destroy$, this.columnDefs);
      }
      else {
        this.reportPaginationService.downloadPDF(this.destroy$, this.columnDefs);
      }
    }
  }

  //This is the flatpicker date setting code, It originally does not send a string, so conversion to string is necessary, And the taking out the from date and to date differently

  monthPlugins = [
    monthSelectPlugin({
      shorthand: true,  // shows "Jan", "Feb"
      dateFormat: 'Y-m', // backend format
      altFormat: 'F Y',  // UI display format
      theme: 'light'     // can be 'dark' too
    })
  ];
  setupMonthPicker() {
    this.plugins = [
      monthSelectPlugin({
        shorthand: true,
        dateFormat: 'Y-m',
        altFormat: 'F Y',
        theme: 'light',
      }),
    ];
    this.altFormat = 'F Y';
    this.dateFormat = 'Y-m';
    this.placeholder = 'Select month';
    this.rangeMode = 'single';
    if (Array.isArray(this.dateRange)) {
      this.dateRange = this.dateRange[1] || this.dateRange[0] || new Date();
    } else if (!this.dateRange) {
      this.dateRange = new Date();
    }
  }

  setupDatePicker() {
    this.plugins = []; // no plugins for normal date picker
    this.altFormat = 'd/m/Y';
    this.dateFormat = 'Y-m-d';
    this.placeholder = 'From - To';
    this.rangeMode = 'range';
    if (!Array.isArray(this.dateRange) || this.dateRange.length < 2) {
      this.dateRange = [
        new Date(new Date().setDate(new Date().getDate() - 1)),
        new Date(),
      ];
    }
  }
  updateFormattedDates(): void {
    if (!this.DateFilterShow) return;

    const formatDate = (d: Date) => {
      if (this.mode === 'month') {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        return `${y}-${m}`;
      }
      return d.toISOString().split("T")[0];
    };
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    this.formattedFromDate = "";
    this.formattedToDate = "";

    let fromDate: Date | null = null;
    let toDate: Date | null = null;

    if (typeof this.dateRange === "string") {
      const trimmed = (this.dateRange as string).trim();
      if (this.mode === 'month' || !trimmed.includes(" to ")) {
        const parsed = new Date(trimmed);
        fromDate = isNaN(parsed.getTime()) ? null : parsed;
        toDate = fromDate;
      } else {
        const [fromStr, toStr] = trimmed.split(" to ");
        fromDate = new Date(fromStr.trim());
        toDate = toStr ? new Date(toStr.trim()) : null;
      }
    } else if (Array.isArray(this.dateRange)) {
      fromDate = this.dateRange[0];
      toDate = this.dateRange[1] ?? (this.mode === 'month' ? this.dateRange[0] : null);
    } else if (this.dateRange instanceof Date) {
      fromDate = this.dateRange;
      toDate = this.dateRange;
    }

    // Normalize date parts to ignore time
    const isSameDay = (d1: Date, d2: Date) =>
      d1.toDateString() === d2.toDateString();

    if (fromDate instanceof Date && !isNaN(fromDate.getTime())) {
      if (toDate instanceof Date && !isNaN(toDate.getTime())) {
        // ✅ Case 1: Both dates selected
        this.formattedFromDate = formatDate(fromDate);
        this.formattedToDate = formatDate(toDate);
      } else {
        if (this.mode === 'month') {
          // If only 1 month selected in month mode, use it for both
          this.formattedFromDate = formatDate(fromDate);
          this.formattedToDate = formatDate(fromDate);
        } else if (isSameDay(fromDate, today)) {
          // ✅ Case 2: Only today selected — auto use yesterday as from
          this.formattedFromDate = formatDate(yesterday);
          this.formattedToDate = formatDate(today);
        } else {
          // ❌ Case 3: Only 1 non-today date selected — ignore
          console.warn("Only one non-today date selected — skipping emit.");
          return;
        }
      }
    } else {
      // ❌ Case 4: Invalid date(s)
      console.warn("Invalid date range selected.");
      return;
    }

    const payload: any = {
      from_date: this.formattedFromDate,
      to_date: this.formattedToDate,
      date: this.mode === 'month' ? (this.formattedToDate || this.formattedFromDate) : undefined
    };

    console.log("Raw dateRange value:", this.dateRange);
    console.log("[applyFilters] Emitting payload to parent:", payload);
    this.filtersApplied.emit(payload);
  }


  // This code Below is to fetch data for different Tables for site summary , Each case is Sending different parameters value for different routes
  private fetchData(type: string | null) {
    // ✅ Step 1: Clear table immediately (so the user sees an empty table)
    this.columnDefs = [];
    this.rowData = [];
    this.loader = true
    // ✅ Step 2: Unsubscribe from any previous API call to prevent interference
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    const timerSuffix =
      !isNaN(Number(this.timer)) && Number(this.timer) !== 0
        ? ` ${this.timerheader}`
        : '';
    let apiCall$; // Declare observable for API call
    let spanrowParam = "";
    switch (type) {

      case "cb":
        this.TableHeader = 'Total CB'
        this.totalDisplay = true
        apiCall$ = this.apiService.getCBList(this.siteid || '');
        this.ExportFileName = 'CB Data'
        break;
      case "disconnected_meter":
        this.TableHeader = 'Disconnected Meter'
        this.totalDisplay = true
        apiCall$ = this.apiService.getDisconnedtedMeters(this.siteid || '');
        this.ExportFileName = 'Disconnected Meter Data'
        break;
      case "dg_meter":
        this.TableHeader = 'Diesel Generator'
        this.totalDisplay = true
        apiCall$ = this.apiService.getDgStatus(this.siteid || '');
        this.ExportFileName = 'Diesel Generator Data'
        break;
      case "meter":
        this.TableHeader = 'Total Meter'
        this.totalDisplay = true
        apiCall$ = this.apiService.getSensorList(this.siteid || '');
        this.ExportFileName = 'Meter Data'
        break;
      case "detailed_meter":
        this.TableHeader = 'Total Meter'
        this.totalDisplay = true
        this.pageNation = false
        apiCall$ = this.apiService.getDetailedSensorList(this.siteid || '');
        this.ExportFileName = 'Meter Data'
        break;
      case "woq":
        this.TableHeader = 'Total W.O.Q'
        this.totalDisplay = true
        apiCall$ = this.apiService.getWOQtyList();
        this.ExportFileName = 'WOQ Data'
        break;
      case "DG":
        spanrowParam = "short_code";
        this.ExportFileName = 'DG Data'
        this.TableHeader = 'DG On' + timerSuffix;
        apiCall$ = this.apiService.getTableData(
          this.TotalRows,
          this.timer,
          "DGON",
          "L",
          this.site_id
        );
        break;
      case "GRID":
        spanrowParam = "short_code";
        this.ExportFileName = 'Grid Data'
        this.TableHeader = 'Grid On' + timerSuffix
        apiCall$ = this.apiService.getTableData(
          this.TotalRows,
          this.timer,
          "GRIDON",
          "L",
          this.site_id
        );
        break;
      case "GridOverload":
        spanrowParam = "short_code";
        this.ExportFileName = 'Grid-Overload Data'
        this.TableHeader = 'Grid Overload' + timerSuffix
        apiCall$ = this.apiService.getTableData(
          this.TotalRows,
          this.timer,
          "OVERLOAD-GRID",
          "L",
          this.site_id
        );
        break;
      case "DGOverload":
        spanrowParam = "short_code";
        this.ExportFileName = 'DG-Overload Data'
        this.TableHeader = 'DG Overload' + timerSuffix
        apiCall$ = this.apiService.getTableData(
          this.TotalRows,
          this.timer,
          "OVERLOAD-DG",
          "L",
          this.site_id
        );
        break;
      case "zeroReading":
        spanrowParam = "short_code";
        this.ExportFileName = 'Zero Reading Data'
        this.TableHeader = 'Zero Reading' + timerSuffix
        apiCall$ = this.apiService.getTableData(
          this.TotalRows,
          this.timer,
          "SENSORZEROREADING",
          "L",
          this.site_id
        );
        break;
      case "lowbalance":
        spanrowParam = "short_code";
        this.ExportFileName = 'Low Balance Data'
        this.TableHeader = 'Low Balance' + timerSuffix
        apiCall$ = this.apiService.getTableData(
          this.TotalRows,
          this.timer,
          "LOW-BALANCE",
          "L",
          this.site_id
        );
        break;
      case "sensorCutOff":
        spanrowParam = "short_code";
        this.ExportFileName = 'Meter Cut Off Data'
        this.TableHeader = 'Meter Cut Off' + timerSuffix
        apiCall$ = this.apiService.getTableData(
          this.TotalRows,
          this.timer,
          "SENSORCUTOFF-L",
          "",
          this.site_id
        );
        break;
      case "cbNotConnected":
        spanrowParam = "short_code";
        this.ExportFileName = 'CB Not Connected Data'
        this.TableHeader = 'CB Not Connect Since' + timerSuffix

        apiCall$ = this.apiService.getTableData(
          this.TotalRows,
          this.timer,
          "CBNOTCONNECT",
          "L",
          this.site_id
        );
        break;
      case "dlNotConnected":
        spanrowParam = "short_code";
        this.ExportFileName = 'Gateway Not Connected Data'
        this.TableHeader = 'Gateway Not Connect' + timerSuffix
        apiCall$ = this.apiService.getTableData(
          this.TotalRows,
          this.timer,
          "DLNOTCONNECT",
          "L",
          this.site_id
        );
        break;
      case "ConsumptionWORecharge":
        spanrowParam = "short_code";
        this.ExportFileName = 'Consumption Without Recharge Data'
        this.TableHeader = 'Consumption Without Recharge'
        apiCall$ = this.apiService.GetConsumptionWORecharge(this.timer, 'L', this.site_id);

        break;
      default:
        this.loader = false;
        this.isLoading = false;
        this.tableService.processTableData(null);
        return;
    }

    // ✅ Step 3: Subscribe to the new API call and process data
    this.dataSubscription = apiCall$.subscribe({
      next: (data) => {
        if (this.isSiteCode) {
          this.onFilterTextBoxChanged();
        }
        this.tableService.processTableData(data, spanrowParam, true);
      },
      error: () => {
        this.tableService.processTableData(null); // Ensure table clears on error
      },
    });
  }

  override ngOnDestroy() {
    this.showmodal = false

    window.removeEventListener('resize', this.onWindowResize);
    console.log('destroy');

    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    if (this.rowdatasubscription) {
      this.rowdatasubscription.unsubscribe();
    }
    if (this.shortCodeSubscription) {
      this.shortCodeSubscription.unsubscribe();
    }
    if (this.siteidSubscription) {
      this.siteidSubscription.unsubscribe();
    }
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
    if (this.gridApi && !this.gridApi.isDestroyed()) {
      this.gridApi.setGridOption('rowData', []);
      this.gridApi.setGridOption('pinnedBottomRowData', []);
      this.gridApi.destroy(); // VERY important
    }

    // Force-hide modal if still present
    this.tableService.processTableData([])
    this.pageNation = false;
    this.columnDefs = [];
    this.rowData = [];

  }

  // Below code is for all the toggles , Search , Column search filter, show columns, download csv 
  onFilterTextBoxChanged(): void { // Quick filter code , AG-grid

    const filterText = (
      document.getElementById("filter-text-box") as HTMLInputElement
    ).value;

    // Apply the quick filter
    this.gridApi.setGridOption("quickFilterText", filterText);

    // Reset pagination offset and stop additional data fetching when filtering is applied
    if (filterText) { // These checks is so that incase while searching, The pagination bit of code does not work, as it can cause issue with pageSize and numbers checks
      this.isQuickFilterActive = true;
    } else {
      this.isQuickFilterActive = false;
    }
  }
  onMainSearchChange(): void { // Quick filter code , AG-grid
    if (this.gridApi) {
      this.gridApi.setFilterModel(null); // Reset all filters
      this.gridApi.onFilterChanged();    // Notify grid of filter change
      this.gridApi.refreshHeader();      // Refresh header to clear floating filter UI
    }
    const filterText = (
      document.getElementById("filter-text-box") as HTMLInputElement
    ).value;

    // Apply the quick filter
    this.gridApi.setGridOption("quickFilterText", filterText);

    // Reset pagination offset and stop additional data fetching when filtering is applied
    if (filterText) { // These checks is so that incase while searching, The pagination bit of code does not work, as it can cause issue with pageSize and numbers checks
      this.isQuickFilterActive = true;
    } else {
      this.isQuickFilterActive = false;
    }
  }


  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {  //Show or hide the column for the column chooser
    const target = event.target as HTMLElement;
    const columnMenuElement = document.querySelector(".column-menu-wrapper");

    if (
      this.showColumnMenu &&
      columnMenuElement &&
      !columnMenuElement.contains(target)
    ) {
      this.showColumnMenu = false; // Hide the column menu
    }
  }

  toggleColumnVisibilityByField(field: string, show: boolean): void { //Show or hide Specific column
    const colDef = this.columnDefs.find((col) => col.field === field);
    if (colDef) {
      colDef.hide = !show; // Set visibility based on the `show` parameter
      this.columnDefs = [...this.columnDefs]; // Trigger change detection
      console.log(
        `Column "${field}" visibility set to: ${show ? "visible" : "hidden"}`
      );
    } else {
      console.warn(`Column with field "${field}" not found.`);
    }
  }
  hideAll() {
    //hide all columns
    this.columnDefs.forEach((colDef) => (colDef.hide = true));
    this.columnDefs = [...this.columnDefs];
    this.isHideAllDisabled = true;
    this.isShowAllDisabled = false;
  }

  showAll() {
    //show all columns
    this.columnDefs.forEach((colDef) => (colDef.hide = false));
    this.columnDefs = [...this.columnDefs];
    this.isHideAllDisabled = false;
    this.isShowAllDisabled = true;
  }

  toggleFloatingFilter() { // Individual column filters
    this.isFloatingFilterEnabled = !this.isFloatingFilterEnabled;
    this.filterIcon = this.isFloatingFilterEnabled
      ? "assets/images/Icons/filter-active.png"
      : "assets/images/Icons/filter.png";
    this.defaultColDef = {
      ...this.defaultColDef,
      floatingFilter: this.isFloatingFilterEnabled,
    };
    this.columnDefs = this.columnDefs.map(col => ({
      ...col,
      floatingFilter: this.isFloatingFilterEnabled
    }));
    if (this.gridApi) {
      this.gridApi.setGridOption('columnDefs', this.columnDefs);
    }
  }

  toggleColumnMenu(event: MouseEvent) {
    event.stopPropagation(); // Prevent the click event from propagating to the document
    this.showColumnMenu = !this.showColumnMenu;
  }
  toggleSearch() {
    this.isSearchOpen = !this.isSearchOpen;

    if (this.isSearchOpen) {
    }
  }
  handleTypeQueryParam(): void {
    const type = this.route.snapshot.queryParamMap.get('type');
    if (!type) return;
    this.toggleColumnVisibilityByField('admin_status', true);
    setTimeout(() => {
      this.onCellFiltter(type, 'admin_status')
    }, 100);

  }

  toggleColumnVisibility(colDef: any) {// Selected Columns are Shown and hidden
    console.log(colDef);
    colDef.hide = !colDef.hide;
    this.columnDefs = [...this.columnDefs];
    this.isHideAllDisabled = false;
    this.isShowAllDisabled = false;
  }


  basicdropdownitem: any[] = [];
  isLoaded: boolean = false;

  CreateBulkAction() {
    window.location.href = 'CreateBulkAction';
  }
  loadSites(): void {
    this.apiService.getSiteList().subscribe(data => {
      this.internalOptions = data.Data.list;
    });
  }

  get filteredItems(): Site[] {
    if (!this.internalOptions.length) return [];
    if (!this.searchTerm.trim()) return this.internalOptions;

    const lower = this.searchTerm.toLowerCase();
    return this.internalOptions.filter(site =>
      site.site_name.toLowerCase().includes(lower)
    );
  }

  selectOption(site: Site) {
    this.searchTerm = site.site_name;   // 👈 input box me selected naam dikhega
    this.selectedValue = site.site_id;  // 👈 selected id rakhega
  }

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchTerm = input.value;
    this.selectedValue = '';  // 👈 input edit kare to selected id reset
  }

}


